const NOT_LISTABLE_DEFINITIONS = new Set([
	'comment',
	'inspector_comment',
	'inspector_decision',
	'meta',
	'method',
	'status'
])

export function isListableDefinition (name?: string | null): boolean {
	return !name || !NOT_LISTABLE_DEFINITIONS.has(name)
}
